export default {
  getRepliquesNFeTableHeaders(state) {
    return state.repliquesNFeTableHeaders;
  },
  getRepliquesNFeTableItems(state) {
    return state.repliquesNFeTableItems;
  },
  getFiltros(state) {
    return state.filtros;
  },
};
